import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { toolkitTestIds } from "../../../constants";
import Text from "../Text/Text";
/**
 * The NumberI18N component is a formatted text component that displays a given
 * number value using internationalization (i18n) formatting. It utilizes the
 * Text component and provides additional formatting options for i18n numbers.
 *
 * @component
 * @param {INumberI18NProps} props - The props for the NumberI18N component.
 * @param {Intl.NumberFormatOptions} [props.formatOpts] - Custom formatting options for the i18n number value.
 * @param {string} [props.locale] - The locale used for formatting the number value. Default is "en".
 * @param {boolean} [props.privacy] - If true, hides the number value. Default is false.
 * @param {string} [props.testId="number-i18n"] - The test id for the NumberI18N component.
 * @param {number | bigint} props.value - The number value to be formatted and displayed.
 * @returns {JSX.Element} A rendered NumberI18N component.
 */
const NumberI18N = ({ formatOpts, locale = "en", privacy = false, testId = toolkitTestIds.numberI18n, value, ...textProps }) => {
    const formattedValue = useMemo(() => new Intl.NumberFormat(locale, { ...formatOpts }).format(value), [locale, formatOpts, value]);
    return (_jsx(Text, { ...textProps, tag: "span", testId: testId, children: privacy && formattedValue
            ? "*".repeat(formattedValue.length)
            : formattedValue }));
};
export default NumberI18N;
//# sourceMappingURL=NumberI18N.js.map